import ViewSwitch from '@dc/ui-library/src/organisms/ViewSwitch/ViewSwitch';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import React from 'react';
import uiLocale from '../../../utils/UILocale.js';

const title = uiLocale.getString('component.viewswitch.title');
const gridButtonLabel = uiLocale.getString('component.viewswitch.grid_button_label');
const listButtonLabel = uiLocale.getString('component.viewswitch.list_button_label');

export default function initViewSwitch() {
  const mountEl = document.querySelector('[data-component="list-page-view-switch"]');
  if (!mountEl) {
    return;
  }
  function mapStateToProps(state) {
    return {
      view: state.listingPage.pageSetup.viewSwitch
    };
  }
  const ConnectedViewSwitch = connect(mapStateToProps)(ViewSwitch);

  if (mountEl) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ConnectedViewSwitch
          title={title}
          gridButtonLabel={gridButtonLabel}
          listButtonLabel={listButtonLabel}
        />
      </Provider>, mountEl
    );
  }
}
